module.exports = function getResource(label, vars = []) {
    let resources = {
        birthdayGift: 'Cadeau d’anniversaire',
        free: 'GRATUIT',
        welcomeKit: 'Trousse de bienvenue',
        rouge: 'Rouge',
        orderFullSizeButton: 'Commander le grand format',
        qty: 'Qté'
    };

    return resources[label];
};
